import {
	CreditCardMasterCardIcon,
	CreditCardMirIcon,
	CreditCardVisaIcon,
} from '@/shared';

type CreditCardIconProps = {
	firstSixDigits: string;
};

export function CreditCardIcon({ firstSixDigits }: CreditCardIconProps) {
	if (firstSixDigits.startsWith('2')) {
		return <CreditCardMirIcon className="w-6" />;
	}
	if (firstSixDigits.startsWith('4')) {
		return <CreditCardVisaIcon className="w-6" />;
	}
	if (firstSixDigits.startsWith('5')) {
		return <CreditCardMasterCardIcon className="w-6" />;
	}
	return null;
}
